import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { ArticleShareEmailIcon, ArticleShareFacebookIcon, ArticleShareGeneralIcon, ArticleShareTwitterIcon } from 'components/icons'
import { getShareLink } from 'data/helpers/share'
import { Share } from 'data/enums/share-target'
import ArticleShareModal from 'components/magazines/ArticleShareModal'
import { useRouter } from 'next/router'

const ShareIcon = ({ children, onClick = () => { }, href = null }) => {
  return (
    <div className="self-end transition-all duration-300 hover:pb-5">
      <a
        className="w-full rounded-full"
        href={href} target="_blank" rel="noreferrer"
      >
        <button
          className="p-10 transition-all duration-300 rounded-full bg-grey-225 hover:bg-grey-150"
          onClick={onClick}
        >
          {children}
        </button>
      </a>
    </div>
  )
}

ShareIcon.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
  href: PropTypes.string,
}

const ShareIcons = ({ article }) => {
  const [shareArticleModalOpen, setShareArticleModalOpen] = useState(false)
  const [shareUrl, setShareUrl] = useState(`/magazine/${article.slug}`)

  const router = useRouter()

  useEffect(() => {
    setShareUrl(`/magazine/${article.slug}`)
  }, [article])

  return (
    <div className="flex gap-8 h-[41px]">
      <ShareIcon
        href={getShareLink(Share.FACEBOOK, shareUrl)}
      >
        <ArticleShareFacebookIcon />
      </ShareIcon>

      <ShareIcon
        href={getShareLink(Share.TWITTER, shareUrl, article.title)}
      >
        <ArticleShareTwitterIcon className="text-white"/>
      </ShareIcon >

      <ShareIcon
        href={getShareLink(Share.EMAIL, shareUrl, article.title)}
      >
        <ArticleShareEmailIcon />
      </ShareIcon >

      <ShareIcon
        onClick={() => setShareArticleModalOpen(true)}
      >
        <ArticleShareGeneralIcon />
      </ShareIcon>

      <ArticleShareModal
        isOpen={shareArticleModalOpen}
        onClose={() => setShareArticleModalOpen(false)}
        href={router.asPath}
      />
    </div >
  )
}

ShareIcons.propTypes = {
  article: PropTypes.object,
}

export default ShareIcons
